import styled, { css } from "styled-components";
import { detailActionButtonCss } from "./detailActionButtonCss";

/** Cancel / Previous / Next on multi-step setup wizards (matches order detail outline actions). */
export const setupWizardActionButtonCss = css`
  ${detailActionButtonCss}
  transition:
    background-color 0.15s ease,
    border-color 0.15s ease,
    color 0.15s ease;
`;

export const SetupWizardActionButtons = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;

  button {
    ${setupWizardActionButtonCss}
  }
`;
